import { Component } from '@angular/core';

@Component({
  selector: 'app-status-info-modal',
  templateUrl: 'status-info-modal.component.html',
  styleUrls: ['../surat-jalan-baterai-module.scss']
})
export class StatusInfoModal {

  constructor(){
  }

  isOpen: boolean = false;

  ticketStatusList = [
    {
      title: 'Open',
      description: 'Tiket dibuka dan masih dalam proses.',
      icon: '',
    },
    {
      title: 'Closed',
      description: 'Tiket sudah ditutup dan proses selesai.',
      icon: '',
    },
  ]

  sjbStatusList = [
    {
      title: 'Draft',
      description: 'Surat jalan baru dibuat, belum disubmit.',
      icon: '',
    },
    {
      title: 'Submitted',
      description: 'Surat jalan telah disubmit',
      icon: '',
    },
    {
      title: 'Approved',
      description: 'Permintaan surat jalan disetujui.',
      icon: '',
    },
    {
      title: 'On Delivery',
      description: 'Barang sedang dalam perjalanan.',
      icon: '',
    },
    {
      title: 'Delivered',
      description: 'Barang sudah sampai tujuan & terverifikasi.',
      icon: '',
    },
    {
      title: 'Rejected',
      description: 'Surat jalan dibatalkan karena alasan tertentu.',
      icon: '',
    },
  ]

  openModal() {
    this.isOpen = true;
  }

  closeModal() {
    this.isOpen = false;
  }
}
